import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=1af002c7&"
import script from "./Collaborators.vue?vue&type=script&lang=js&"
export * from "./Collaborators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports